module.exports = __webpack_public_path__ + "static/media/lamaia-si-coronovirusul.787da366.jpeg";